/**
 * Labstep
 *
 * @module components/PermissionRole/Action/Delete
 * @desc Delete resource location
 */

import { EntityActionDelete } from 'labstep-web/components/Entity/Action/Delete';
import type React from 'react';
import type { IPermissionRoleActionDeleteProps } from './types';

export const PermissionRoleActionDelete: React.FC<
  IPermissionRoleActionDeleteProps
> = ({ permissionRole }) => (
  <EntityActionDelete entity={permissionRole} />
);
